import { render, staticRenderFns } from "./ContactText.vue?vue&type=template&id=ee90f086&"
import script from "./ContactText.vue?vue&type=script&lang=js&"
export * from "./ContactText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports